import React from 'react';

function Logo() {
  return (
    <div className="item logo" id="logo-banner"></div>
  )
}

export default Logo